import { Recycle } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import BrandHarvestSelector from "@/components/admin/BrandHarvestSelector";

/** Platform › Data › Brand harvest defaults (superadmin). Writes brand_harvest_components. */
export default function BrandHarvestDefaults() {
  const { data: categories = [] } = useQuery({
    queryKey: ["harvest_component_categories_system"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("harvest_components")
        .select("appliance_category")
        .eq("is_system_default", true);
      if (error) throw error;
      return Array.from(new Set((data || []).map((r) => r.appliance_category).filter(Boolean) as string[])).sort();
    },
  });

  return (
    <div className="min-h-screen bg-background pb-24">
      <div className="px-6 pt-8 pb-6">
        <div className="flex items-center gap-2 mb-1">
          <Recycle className="w-5 h-5 text-primary" />
          <h1 className="text-2xl font-bold text-foreground">Brand harvest defaults</h1>
        </div>
        <p className="text-muted-foreground">
          Default components to harvest per brand and appliance type. Companies start with these and can add or remove components for themselves.
        </p>
      </div>
      <div className="px-6 max-w-4xl">
        <BrandHarvestSelector mode="default" categories={categories} />
      </div>
    </div>
  );
}
